import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import CoreMap from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import CommunityCard from '../../components/CommunityCard';
import CommunityMapCard from '../../components/CommunityMapCard';
import { colors } from '../../styles';

const styles = css`
  .Communities_communitiesResults {
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      display: flex;
    }
  }

  .Communities_communitiesList {
    position: relative;
    z-index: 1;
    height: auto;
    width: 100%;
    padding: 30px;
    margin-top: -500px;
    min-height: 650px;
    background-color: ${colors.color3Light};
    @media (max-width: 991px) {
      &.Communities_communitiesList--hide {
        display: none;
      }
    }
    @media (min-width: 992px) {
      width: 553px;
      padding: 20px;
      height: 500px;
      overflow-y: scroll;
      margin-top: 0;
    }
  }
  .ShowMap_button {
    position: absolute;
    background-color: ${colors.color2};
  }
`;

const communityMap = css`
  position: relative;
  height: calc(100vh - 115px);
  max-height: 650px;
  width: 100%;
  z-index: 0;

  @media (min-width: 992px) {
    height: unset;
    width: auto;
    flex-grow: 1;
  }

  background-color: ${colors.color3};
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
  }
`;

function CommunityResults({ activeMapPin, communities, sort, showMap }) {
  return (
    <div className={styles}>
      <div className="Communities_communitiesResults">
        <CoreMap
          animate
          useFlyTo
          boundsOptions={{ animate: true, duration: 0.5 }}
          pin={{
            iconUrl: '/images/icon-map-pin-woodbridge.svg',
            iconSize: [32, 46],
            iconAnchor: [16, 46],
            popupAnchor: [0, -41],
          }}
          activePin={activeMapPin}
          className={communityMap}
          markers={communities}
          popup={({ marker: community }) => (
            <CommunityMapCard community={community} />
          )}
        />
        <div className={`Communities_communitiesList ${showMap ? 'Communities_communitiesList--hide' : ''}`}>
          {
            orderBy(communities, sort.field, get(sort, 'dir', 'asc')).map(community => (
              <CommunityCard key={community._id} community={community} />
            ))
          }
        </div>
      </div>
    </div>
  );
}

CommunityResults.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeMapPin: PropTypes.string,
  sort: PropTypes.object,
  showMap: PropTypes.bool.isRequired,
};

CommunityResults.defaultProps = {
  activeMapPin: undefined,
  sort: {},
};

export default withData({
  communities: true,
})(CommunityResults);



// WEBPACK FOOTER //
// ./src/pages/Communities/CommunityResults.js